<template>
  <Fragment>
    <img
      :src="imageSrc"
      :class="imageDefaultClass"
      :alt="imageAlt"
      :style="imageStyle"
      @mousedown="startDrag"
      @mouseup="stopDrag"
      @mousemove="drag"
      @mouseleave="stopDrag"
      @touchstart="startTouch"
      @touchmove="dragTouch"
      @touchend="stopDrag"
    />
    <ship-button
      :display-close-modal-button="displayCloseModalButton"
      :display-fullscreen-button="displayFullscreenButton"
      @scale-changed="handleUpdatedScale"
    />
  </Fragment>
</template>

<script>
import ShipButton from './ship-button.vue';
import { Fragment } from 'vue-fragment';
export default {
  name: 'ShipImageZoom',
  components: {
    'ship-button': ShipButton,
    Fragment
  },
  props: {
    displayCloseModalButton: {
      type: Boolean,
      default: false
    },
    displayFullscreenButton: {
      type: Boolean,
      default: true
    },
    imageSrc: {
      type: String,
      required: true
    },
    imageDefaultClass: {
      type: String,
      default: 'fullimage'
    },
    imageAlt: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      scale: 1,
      position: { x: 0, y: 0 },
      isDragging: false,
      lastMousePosition: { x: 0, y: 0 }
    };
  },
  computed: {
    imageStyle() {
      return {
        transform: `translate(${this.position.x}px, ${this.position.y}px) scale(${this.scale})`,
        position: 'relative',
        transition: this.isDragging ? 'none' : 'transform 0.2s ease',
        cursor: this.isDragging ? 'grabbing' : 'grab'
      };
    }
  },
  methods: {
    handleUpdatedScale(updatedScale) {
      this.scale = updatedScale;
      if (updatedScale === 1) {
        this.position = { x: 0, y: 0 };
      }
    },
    startDrag(event) {
      this.isDragging = true;
      this.lastMousePosition = { x: event.clientX, y: event.clientY };
      event.preventDefault();
    },
    startTouch(event) {
      if (event.touches.length === 1) {
        const touch = event.touches[0];
        this.isDragging = true;
        this.lastMousePosition = { x: touch.clientX, y: touch.clientY };
      }
    },
    stopDrag() {
      this.isDragging = false;
    },
    drag(event) {
      this.handleDrag(event, false);
    },
    dragTouch(event) {
      this.handleDrag(event, true);
    },
    handleDrag(event, isTouch = false) {
      if (!this.isDragging || this.scale < 2) return;
      if (isTouch && event.touches.length !== 1) return;

      const clientX = isTouch ? event.touches[0].clientX : event.clientX;
      const clientY = isTouch ? event.touches[0].clientY : event.clientY;

      const dx = clientX - this.lastMousePosition.x;
      const dy = clientY - this.lastMousePosition.y;

      let newX = this.position.x + dx;
      let newY = this.position.y + dy;

      const imgElement = event.target;
      const parentElement = imgElement.parentElement;

      const parentRect = parentElement.getBoundingClientRect();
      const imgRect = imgElement.getBoundingClientRect();

      const imgWidth = imgRect.width * this.scale;
      const imgHeight = imgRect.height * this.scale;

      const offsetX = imgWidth * 0.5;
      const offsetY = imgHeight * 0.5;

      const minX = parentRect.left - imgRect.left - offsetX;
      const maxX = parentRect.right - imgRect.right + offsetX;
      const minY = parentRect.top - imgRect.top - offsetY;
      const maxY = parentRect.bottom - imgRect.bottom + offsetY;

      newX = Math.max(minX, Math.min(newX, maxX));
      newY = Math.max(minY, Math.min(newY, maxY));

      this.position.x = newX;
      this.position.y = newY;

      this.lastMousePosition = { x: clientX, y: clientY };

      if (isTouch) event.preventDefault();
    }
  }
};
</script>
